import { render, staticRenderFns } from "./CityDelete.vue?vue&type=template&id=197a525c&scoped=true&"
import script from "./CityDelete.vue?vue&type=script&lang=js&"
export * from "./CityDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a525c",
  null
  
)

export default component.exports